






































import {Vue, Prop, Component} from 'vue-property-decorator'
import {Letter} from "@/store/models/Letter/Letter";
import {getPersianDate} from "@/util/utils";
import * as api from '@/store/Services/letterServices';
import { DateBaseOnCurrentTimeConverter } from '@/util/dateConverter';
import * as letterService from '@/store/Services/letterServices';
import { LetterSearchResult } from '../../../../store/models/Letter/LetterSearchResult';
import * as enterpriseFormService from '@/store/Services/enterpriseFormService';

@Component
export default class SearchResultItemMobile extends Vue{
    @Prop() letterData?: LetterSearchResult 
    isOpenned = false;

    isSent = false;
    @Prop() serverTime?: string;
    
    async created(){
    if(this.letterData === undefined) return;
         if(this.letterData.from === null || this.letterData.from === undefined){
             this.isSent = true;
         }

        
    }

    get priorityColor(){
        if(this.letterData === undefined)return '';
        if(this.letterData.priority<5)
            return  {'background-color':'#69b578'};
        if(this.letterData.priority === 5)
            return  {'background-color':'#e9c46a'}; 
        else
            return {'background-color':'#ff6b6b'};
    }

    get  sendTime(){
        if(this.letterData === undefined) return '';
        if(!this.serverTime)return '';
        const dateConverter = new  DateBaseOnCurrentTimeConverter();
        return   dateConverter.getDateString(new Date(this.letterData.sendTime.substring(0,this.letterData.sendTime.length -1)),this.serverTime)
    }

   async select(){
        
        if(this.letterData === undefined)return;
            if(this.letterData.isOpenned === false){
                api.OpenLetter(this.letterData.possessionId);
                //store.state.eventHub.$emit('letter-opened');
                if(this.letterData.isEnterpriseForm)
                   if( await enterpriseFormService.IsFormAutoClose(this.letterData.enterpriseFormId))
                        this.letterData.isClosed = true;
            }
            this.isOpenned = true;
            this.$emit("letterselected",this.letterData.possessionId);
        
    }

      get receiverStr(){
        if(!this.letterData)return '';
        if(!this.letterData.to)return '';
        if(this.letterData.to.length > 1) return this.letterData.to[0].nameOnly + ' و بیشتر...';
        return this.letterData.to[0].nameOnly;
    }

    

}

